import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router';
import SpaceList from './SpaceList/SpaceList';
import SpaceEdit from './SpaceEdit/SpaceEdit';
import NewsLetter from "../NewsLetter/NewsLetter";
import AssignSpace from '../AssignSpace/AssignSpace'
import NewHostOnboarding from "../NewHostOnboarding/NewHostOnboarding";
import NewHostOnboardingDetails from "../NewHostOnboarding/NewHostOnboardingDetails/NewHostOnboardingDetails";

const Space = () => {
  return (
    <Switch>
      <Route path={'/dashboard/space/space '} component={SpaceList} />
      <Route path={'/dashboard/space/add'} component={SpaceEdit} />
      <Route path={'/dashboard/space/edit'} component={SpaceEdit} />
      <Route path={'/dashboard/newsletter'} component={NewsLetter} />
      <Route path={'/dashboard/space/assignspace'} component={AssignSpace} />
      <Route path={'/dashboard/newHostOnboarding/hosts'} component={NewHostOnboarding} />
      <Route path={'/dashboard/newHostOnboarding/details'} component={NewHostOnboardingDetails} />
      <Route path={'*'} component={SpaceList} />
    </Switch>
  );
};

export default Space;
